import React from 'react';
import classNames from 'classnames';

interface ComponentProps {
  id: string;
  rightCluster?: React.ReactNode;
  leftCluster?: React.ReactNode;
}

const Toolbar: React.FC<ComponentProps> = ({ id, leftCluster, rightCluster }) => {
  const toolbarClassnames = classNames('toolbar', {
    'content-start': !rightCluster && leftCluster,
    'content-end': rightCluster && !leftCluster,
    'content-split': rightCluster && leftCluster,
  });

  return (
    <div id={id} className={toolbarClassnames} data-cy={`${id}-toolbar`}>
      {leftCluster && <div className="inner">{leftCluster}</div>}
      {rightCluster && <div className="inner">{rightCluster}</div>}
    </div>
  );
};

export default Toolbar;
